import * as z from 'zod'

import { FeatureFlagsEnum } from '~/shared/lib/featureFlag/constants'
import { ApiModel } from './core'

const schema = z.object({})

export type FeatureFlagAttributes = z.infer<typeof schema>

export class FeatureFlag extends ApiModel<typeof schema> {
  static jsonApiBaseUrl = 'gitlab'
  static jsonApiType = 'feature-flags'

  static schema = schema

  static async getFlags(): Promise<FeatureFlagsEnum[]> {
    const url = `${this.getJsonApiUrl()}`
    const res = await this.effectiveHttpClient.get(url)
    return res.getData()
  }
}
